import { useRouter } from "next/router";
import { QueryProps } from "@nf/common";

export const useGenreRouter = () => {
  const router = useRouter();
  const params = router.query as QueryProps;
  const mediaListId = params.id ?? -1;
  return { params, mediaListId, router };
};
